import { inject } from '@angular/core';
import { Router, CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { CommonService } from '../services/common.service';

export const publicGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const commonService = inject(CommonService);

  // An already-authenticated user on a public page belongs back in the app —
  // at the deep link they were originally after, if there was one.
  const destination = () =>
    router.parseUrl(commonService.consumeRedirectUrl(route.queryParams['returnUrl']));

  // Check if user is already authenticated without making API call
  if (authService.isAuthenticated()) {
    return destination();
  }

  // If not authenticated, try to authenticate (in case there's a valid token)
  return authService.authenticate().pipe(
    take(1),
    map(isAuthenticated => {
      if (!isAuthenticated) {
        return true;
      }

      return destination();
    })

  );

};
